/**
 * Version 2 to 3: settings arrive.
 *
 * Every version 2 record was written before there was a settings screen, so every version 2
 * character has moved no knobs. The step adds the empty section and nothing else, which is exactly
 * what "everything on its default" already means to the reader.
 *
 * It does not touch `schemaVersion`, and it does not validate, for the reasons `addProgression`
 * states in its own words: `runMigrations` stamps `from + 1`, and `readProfile` validates once
 * after the whole chain has run.
 */

import type { SaveMigration, SaveRecord } from '@/save/migrationContract';

export const ADD_SETTINGS: SaveMigration = {
  from: 2,
  apply(record: SaveRecord): SaveRecord {
    return { ...record, settings: {} };
  },
};
